import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { getNCFileByPartId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { LoadSingleBatch } from '@interfaces/methods';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface PartDetailsBatchDocumentsProps {
  loadSingleBatch: LoadSingleBatch;
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const PartDetailsBatchDocumentsComponent: FC<PartDetailsBatchDocumentsProps> = ({
  getTools,
  clearTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  loadSingleBatch,
  batch,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    getNCFileByPartId,
    operationsSearch,
    loadSingleBatch,
  });

  const batchId = batch?.data?.productionBatchId;

  return (
    <DetailsPageWrapper title={title.batch}>
      {batchId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={batchId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Batch} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const PartDetailsBatchDocuments = connect(({ batch: { batch } }) => ({ batch }), {
  getProductionBatchByPart,
  getTools,
  clearTools,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
  loadSingleBatch,
})(PartDetailsBatchDocumentsComponent);

export { PartDetailsBatchDocuments };
